import React, { Component } from "react";
import axios from "axios";
import LoadingScreen from "react-loading-screen";
import Swal from "sweetalert2";
import { Modal, Table } from "react-bootstrap";
import loader from "../../Resources/loader.gif";

class GrnList extends Component {
  state = {
    token: null,
    loading: false,
    grns: null,
    grnitems: null,
    isOpen: false,
  };

  openModal = (id) => {
    
    if (this.state.token) {
      var config = {
        method: "get",
        url: process.env.REACT_APP_BASE_URL + "/grnitem/" + id,
        headers: {
          Authorization: `Bearer ${this.state.token}`,
        },
      };

     axios(config)
        .then((res) => {
          if (res.data.success) {
            if (res.data.grnitems[0]) {
              this.setState({
                loading: false,
                grnitems: res.data.grnitems,
                isOpen: true 
              });
            } else {
              this.setState({
                loading: false,
              });

              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "No GRN Items found!",
              });
            }
          } else {
            this.setState({
              loading: false,
            });

            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Failed to Load GRN Items!",
            });
          }
        })
    }
   
  };
  closeModal = () => this.setState({ isOpen: false });

  getGrns = async () => {
    this.setState({
      loading: false,
    });
    if (this.state.token) {
      var config = {
        method: "get",
        url: process.env.REACT_APP_BASE_URL + "/grn/all",
        headers: {
          Authorization: `Bearer ${this.state.token}`,
        },
      };

      await axios(config)
        .then((res) => {
          if (res.data.success) {
            if (res.data.grns[0]) {
              this.setState({
                loading: false,
                grns: res.data.grns,
              });
            } else {
              this.setState({
                loading: false,
              });

              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "No GRNs found!",
              });
            }
          } else {
            this.setState({
              loading: false,
            });

            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Failed to Load GRNs!",
            });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  deleteGrn = (id) => {
    Swal.fire({
      title: "Do you want to delete this grn?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
    }).then((result) => {
      if (result.isConfirmed) {
        this.setState({
          loading: true,
        });
        if (this.state.token) {
          var config = {
            method: "delete",
            url: process.env.REACT_APP_BASE_URL + "/customer/" + id,
            headers: {
              Authorization: `Bearer ${this.state.token}`,
            },
          };

          axios(config)
            .then((response) => {
              if (response.data.success) {
                this.setState({
                  loading: false,
                });
                Swal.fire({
                  position: "center",
                  icon: "success",
                  title: "Customer Deleted",
                  showConfirmButton: false,
                  timer: 1500,
                });
                this.getCustomers();
              }
            })
            .catch((error) => {
              this.setState({
                loading: false,
              });

              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "Error!",
              });
            });
        }
      }
    });
  };

  componentDidMount() {
    this.state.token = JSON.parse(sessionStorage.getItem("userToken"));
    this.getGrns();
  }

  render() {
    var ids = this.state.grns ? (
      this.state.grns.map((data, i) => {
        return (
          <tr>
            <td> {data.supplier}</td>

            <td> {data.store}</td>

            <td>
              <button
                onClick={()=>this.openModal(data.id)}
                class="btn btn-primary"
              >
                View
              </button>
            </td>
            <td>
              <button
                onClick={() => this.deleteGrn(data.id)}
                class="btn btn-danger"
              >
                Delete
              </button>
            </td>
          </tr>
        );
      })
    ) : (
      <tr>No Data</tr>
    );
    var grnitems = this.state.grnitems ? (
      this.state.grnitems.map((data, i) => {
        return (
          <tr>
            <td> {data.name}</td>

            <td> {data.unitprice}</td>
            <td> {data.qty}</td>
            <td> {data.total}</td>
            <td> {data.created_at}</td>

          </tr>
        );
      })
    ) : (
      <tr>No Data</tr>
    );
    return (
      <LoadingScreen
        loading={this.state.loading}
        bgColor="#ffffffcc"
        logoSrc={loader}
      >
        <div class="main-container">
          <div class="pd-20 card-box mb-30">
            <div class="clearfix">
              <div class="pull-left d-flex w-100">
                <h1 class="text-center text-blue h2">GRN List</h1>
              </div>
            </div>
          </div>
          <div class="pd-20 card-box mb-30">
            <table class="table">
              <thead>
                <tr>
                  <th>Supplier</th>
                  <th>Store</th>

                  <th></th>
                </tr>
              </thead>
              <tbody>{ids ? ids : <tr value="">No Data</tr>}</tbody>
            </table>
          </div>
        </div>
        <Modal size="lg" show={this.state.isOpen} onHide={this.closeModal}>
          <Modal.Header closeButton>
            <Modal.Title>Grn Items</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Table striped bordered hover>
              <thead>
                <tr>
                  <th>Product Name</th>
                  <th>Unit Price (Cost)</th>
                  <th>Qty</th>
                  <th>Total</th>
                  <th>Created At</th>
                </tr>
              </thead>
              <tbody>
              {grnitems ? grnitems : <tr value="">No Data</tr>}
              </tbody>
            </Table>
          </Modal.Body>
        </Modal>
      </LoadingScreen>
    );
  }
}

export default GrnList;
